import { ReactNode, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Flex, Spinner } from '@radix-ui/themes'
import { useAuth } from './AuthProvider'
import { checkIsSuperAdmin } from './service'

const WEBAPP_URL = import.meta.env.VITE_WEBAPP_URL

type SuperadminGateProps = {
  children: ReactNode
}

const SuperadminGate = ({ children }: SuperadminGateProps) => {
  const { session } = useAuth()

  const { data: isSuperAdmin, isLoading } = useQuery({
    queryKey: ['superadmin-check', session!.user.id],
    queryFn: () => checkIsSuperAdmin(session!.user.id)
  })

  useEffect(() => {
    if (!isLoading && isSuperAdmin === false) {
      window.location.replace(WEBAPP_URL)
    }
  }, [isLoading, isSuperAdmin])

  if (isLoading || isSuperAdmin === false) {
    return (
      <Flex align="center" justify="center" className="h-screen">
        <Spinner size="3" />
      </Flex>
    )
  }

  return <>{children}</>
}

export default SuperadminGate
